import { Page } from '@/core/architecture'

import { ArtistTradeTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ArtistTrade Page
 * Implemented as a practical sample.
 */
export const ArtistTrade: Page = () => {
  const { state, actions } = useViewModel()

  return <ArtistTradeTemplate state={state} onFetchMore={actions.onFetchMore} />
}
